import { render, staticRenderFns } from "./MadFree.vue?vue&type=template&id=b40460f4&scoped=true&"
import script from "./MadFree.vue?vue&type=script&lang=js&"
export * from "./MadFree.vue?vue&type=script&lang=js&"
import style0 from "./MadFree.vue?vue&type=style&index=0&id=b40460f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40460f4",
  null
  
)

export default component.exports